export const lazyLoadVideo = {
    name: 'lazyLoadVideo',
    inserted: (el) => {
      function loadVideo() {
       //const videoElement = Array.from(el.children).find((child) => child.tagName === 'VIDEO');
        const videoElement = el.querySelector('video');
        if (videoElement) {
          videoElement.src = videoElement.dataset.src;
          videoElement.poster = videoElement.dataset.poster;
          videoElement.play(); 
          observer.unobserve(el);
        }
      }
  
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadVideo();
          }
        });
      });
  
      observer.observe(el);
    }
  };
  


  